<template>
  <common-hawb ref="hawb" :context="context" :action="action" :job="job" :form="form" :cooperate-edit="cooperateEdit" />
</template>

<script>
import commonHawb from '@/views/cargo/v0/AirImport/components/booking/tabs/CommonHAWB'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { AirCargoDoc } from '@/class/model/booking/AirCargoDoc'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'

export default {
  name: 'AiTabHBL',
  components: { commonHawb },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    cooperateEdit: { type: Boolean, default: true } // 能否修改
  },
  data() {
    const form = new AirCargoDoc().fillDefaultValue().getData()
    form.otherCharge = []
    return {
      job: new AirImportJob().fillDefaultValue().getData(),
      form
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.job = row
      // CARGO-39083 此处移除相关赋值操作，原数据若无分单信息则不展示JOB相关信息
      // let form = this.getHbl()
      // if (!form) {
      //   form = await new AirCargoDoc().newCargoDoc(this.job, CargoDocConsts.HAWB)
      //   form.signByCarrier = ''
      //   form.signByShipper = ''
      //   form.shipperCode = this.job.shipperCode
      //   form.shipperId = this.job.shipperId
      //   form.shipperLine1 = this.job.shipperLine1
      //   form.consigneeCode = this.job.consigneeCode
      //   form.consigneeId = this.job.consigneeId
      //   form.consigneeLine1 = this.job.consigneeLine1
      //   form.notifyCode = this.job.notifyCode
      //   form.notifyId = this.job.notifyId
      //   form.notifyLine1 = this.job.notifyLine1
      //   form.quantity = this.job.quantityContract
      //   form.weight = this.job.weightContract
      //   form.cubage = this.job.cubageContract
      //   form.cWeight = this.job.chargeWeight
      //   form.cargoEnglishName = this.job.cargoEnglishName
      //   form.remark1 = this.job.mark
      //   this.job.airCargoDoc = this.job.airCargoDoc || []
      //   this.job.airCargoDoc.push(form)
      // }
      const form = await new AirImportJob(row).getCargoDoc(CargoDocConsts.HAWB, true)
      await new AirCargoDoc(form).getOtherCharge()
      this.form = form
      if (!this.form.hblNbr2) {
        this.form.hblNbr2 = row.hbl
      }
      this.$refs.hawb.fillView()
    },
    getHbl() {
      if (this.job.airCargoDoc) {
        return this.job.airCargoDoc.find(p => p.docType === CargoDocConsts.HAWB) || null
      }
      return null
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      if (this.form) {
        // params.JOB_UUID = this.job.uuid
        // params.DOC_UUID = this.form.uuid
        // params.cargoDocUuid = this.form.uuid
        PrintTemplateUtil.buildPrintDataByAihawb(this.job, this.form, params)
        params.category = 'AIHAWB'
        params.ctx = new AirImportJob(this.job)
      }
      return params
    },
    async getSubmitData() {
      return {
        job: this.job,
        airCargoDoc: [this.form]
      }
    },
    executeTask() {
      this.$refs.hawb.executeTask()
    }
  }
}
</script>

<style>
</style>
